module.exports = __webpack_public_path__ + "static/media/17.443c2175.jpg";